<template>
    <div style="width: 100%; height: 43.6px; display: flex; align-items: flex-end; position: relative; justify-content: center; padding-bottom: 1px;">
        <!-- prev & next button -->
        <div style="position: absolute; left: 0; bottom: 1px;">
            <v-btn style="background-color: white !important;" elevation="2" light x-small fab color="white" @click="onClickPrev" :disabled="disabled || !canPrev || loading">
                {{ prevButtonText }}
            </v-btn>
            <v-btn style="background-color: white !important;" elevation="2" light x-small fab color="white" @click="onClickNext" :disabled="disabled || !canNext || loading">
                {{ nextButtonText }}
            </v-btn>
        </div>
        <v-btn style="background-color: white !important;" elevation="2" light x-small fab color="white" @click="onClickPrevBlock" :disabled="!canPrevPageBlock || loading">
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
                v-for="n in totalVisibleComputed"
                elevation="2"
                :disabled="disabled || loading"
                color="white"
                :class="{'vue-data-table-pagination-active': model === calculatedNumber + n}"
                @click="onClickPage(calculatedNumber + n)"
                light x-small fab>{{calculatedNumber + n}}</v-btn>
        <v-btn style="background-color: white !important;" x-small elevation="2" light fab color="white" @click="onClickNextBlock" :disabled="!canNextPageBlock || loading">
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "VueDataTablePagination",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            prevButtonText: {
                type: String,
                default: 'Prev',
            },
            nextButtonText: {
                type: String,
                default: 'Next',
            },
            value: {
                type: Number,
                default: 1,
            },
            itemsPerPage: {
                type: Number,
                default: 15,
            },
            totalVisible: {
                type: Number,
                default: 10,
            },
            totalCount: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            identifier: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                model: this.value,
                currentPageBlockNumber: 1,
            };
        },
        mounted() {
            console.log("jjw vue data table mounted")
        },
        watch: {
            identifier() {
                this.model = 1;
                this.currentPageBlockNumber = 1;
                this.$emit('init');
            },

            value() {
                this.model = this.value;
            },

            model() {
                this.$emit('input', this.model);
            },

            totalCountOfPage() {
                this.$emit('update:total-count-of-page', this.totalCountOfPage);
            },
        },
        computed: {
            totalCountOfPage() {
                return Math.ceil(this.totalCount / this.itemsPerPage);
            },

            /**
             * 마지막 블럭일 경우 페이지 숫자를 맞추어줍니다.
             */
            totalVisibleComputed() {
                if (this.totalCountOfPage === 0) return 1;
                return this.currentPageBlockNumber === this.maxPageBlockNumber ? this.totalCountOfPage - ((this.maxPageBlockNumber - 1) * this.totalVisible) : this.totalVisible;
            },

            /**
             * 최대 페이지 블럭 번호를 반환합니다.
             */
            maxPageBlockNumber() {
                return Math.floor((this.totalCountOfPage - 1) / this.totalVisible) + 1;
            },

            /**
             * 페이지 번호를 기록할 때 계산할 값을 반환합니다.
             * @returns {number}
             */
            calculatedNumber() {
                return (this.currentPageBlockNumber - 1) * this.totalVisible;
            },

            /**
             * 이전 페이지 블럭으로 이동가능한지의 여부입니다.
             */
            canPrevPageBlock() {
                return this.currentPageBlockNumber > 1;
            },

            /**
             * 다음 페이지 블럭으로 이동가능한지의 여부입니다.
             */
            canNextPageBlock() {
                return this.currentPageBlockNumber < this.maxPageBlockNumber;
            },

            /**
             * 이전 페이지로 이동 가능한지
             */
            canPrev() {
                return this.model > 1;
            },

            /**
             * 다음 페이지로 이동 가능한지
             */
            canNext() {
                return this.model < this.totalCountOfPage;
            },
        },
        methods: {
            onClickPage(page) {
                this.model = page;
                this.$emit('paging', this.model);
            },

            /**
             * 이전 페이지 버튼이 클릭되었습니다.
             */
            onClickPrev() {
                if (this.canPrev) {
                    this.model--;
                    this.$emit('paging', this.model);
                }
            },

            /**
             * 다음 페이지 버튼이 클릭되었습니다.
             */
            onClickNext() {
                if (this.canNext) {
                    this.model++;
                    this.$emit('paging', this.model);
                }
            },

            /**
             * 이전 버튼이 클릭되었습니다.
             * 이전 페이지 블럭으로 이동가능하다면 이동합니다.
             */
            onClickPrevBlock() {
                if (!this.canPrevPageBlock) return;
                this.currentPageBlockNumber = this.currentPageBlockNumber - 1;
            },

            /**
             * 다음 버튼이 클릭되었습니다.
             * 다음 페이지 블럭으로 이동가능하다면 이동합니다.
             */
            onClickNextBlock() {
                if (!this.canNextPageBlock) return;
                this.currentPageBlockNumber = this.currentPageBlockNumber + 1;
            },
        },
    }
</script>

<style scoped>
    button:not(:last-child) {
        margin-right: 8px;
    }

    .vue-data-table-pagination-active {
        background: #1867c0 !important;
        color: white !important;
    }

    .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: white !important;
    }
</style>
